














import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class StDeleteButton extends Vue {
  @Prop() loading!: boolean;
  @Prop() tooltipOnBody!: boolean;
  @Prop() small!: boolean;

  @Emit('delete')
  doDelete() {
    return;
  }

  @Emit('startDelete')
  startDelete(){
    return;
  }

  @Emit('endDelete')
  endDelete(){
    return;
  }
}
